import { combineReducers } from 'redux';
import authReducer from './authReducer';
import categoryReducer from './categoryReducer';
import bannerReducer from "./bannerReducer";
import productReducer from "./productReducer"; 
import couponsReducer from './couponReducer';
import orderReducer from "./orderReducer";
import statsReducer from "./statsReducer";
import salesReducer from "./salesReducer";  // Import Sales Reducer


const rootReducer = combineReducers({
  auth: authReducer,
  categories: categoryReducer,
  banners: bannerReducer, 
  product: productReducer,
  coupon: couponsReducer,
  order: orderReducer,
  stats: statsReducer,
  sales: salesReducer, 

});

export default rootReducer;
